import {cn} from '@/lib/utils'

interface BrainLogoProps {
    size?: 'sm' | 'md' | 'lg'
    className?: string
    showGlow?: boolean
    variant?: 'dark' | 'light'
    alt?: string
}

const sizeConfig = {
    sm: {
        container: 'h-8 w-24',
        blur: 'h-8 w-24',
    },
    md: {
        container: 'h-10 w-28',
        blur: 'h-10 w-28',
    },
    lg: {
        container: 'h-16 w-40',
        blur: 'h-16 w-40',
    },
}

const variantSource = {
    dark: '/logo_dark.png',
    light: '/logo_light.png',
}

export function BrainLogo({
    size = 'md',
    className,
    showGlow = true,
    variant = 'dark',
    alt = 'AI Expert Network logo',
}: BrainLogoProps) {
    const config = sizeConfig[size]

    return (
        <div className={cn('relative inline-flex items-center justify-center', config.container, className)}>
            {showGlow && (
                <div
                    className={cn(
                        'absolute inset-0 rounded-2xl bg-gradient-to-r from-color-4 to-color-5 opacity-25 blur',
                        config.blur
                    )}
                />
            )}
            <img
                src={variantSource[variant]}
                alt={alt}
                className={cn('relative z-10 w-auto')}
                loading="lazy"
            />
        </div>
    )
}